// extracted by mini-css-extract-plugin
module.exports = {"dialogBox":"dialogBox--PXM3o","theIcon":"theIcon--1TBJa","title":"title--19E5W","submitButton":"submitButton--2I7Yu","remarkText":"remarkText--8aNt-"};